import request from '@/utils/request'

export function getAll() {
  return request({
    url: 'typeDocument/getAll',
    method: 'get'
  });
}
